'use client';

import { amplitudeAnalytics } from './amplitude-analytics';
import { ComposeAnalytics } from './compose';
import { consoleAnalytics } from './console';

export * as helpers from './helpers';

const envReady = typeof window !== 'undefined' && process.env.NODE_ENV !== 'test';

const initialDestinations = envReady
  ? [amplitudeAnalytics, ...(process.env.NODE_ENV === 'development' ? [consoleAnalytics] : [])]
  : [];

export const analytics = new ComposeAnalytics(initialDestinations);
